import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { boatTypeActions, leaderboardActions } from "../../../../redux/actions";
import { sportConstants, translationConstants } from "../../../../constants";

import LeaderboardDetail from "./LeaderboardDetails";
import FilterComponent from "./FilterComponent";

import { DateObject } from "react-multi-date-picker";

const currentYear = new DateObject().year;
const defaultQueryExpression = `Year = ${currentYear}`;
const initialGridState = {
  length: 15,
  search: "",
  pageNumber: 1,
  orderBy: "",
  filterQuery: defaultQueryExpression,
  partitionFilter: "",
};

const Leaderboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [gridState, setGridState] = useState(initialGridState);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Manage selected tab index

  // Map activeTabIndex to sportConstants values
  const sportIdMapping = {
    0: sportConstants.SAILING,
    1: sportConstants.KITESURFING,
    2: sportConstants.WINDSURFING,
    3: sportConstants.WINGFOILING,
  };

  const currentSportId = sportIdMapping[activeTabIndex];

  useEffect(() => {
    dispatch(
      leaderboardActions.getLeaderboardBoatClasses(parseInt(currentYear))
    );
    //eslint-disable-next-line
  }, []);

  return (
    <div className="container px-0 d-flex flex-md-row flex-column">
      <div className="col-md-10 col-12">
        <div className="py-2">
          <div className="col-md-12 leaderboard view-center-profile-scroll-tabs">
            <Tabs onSelect={(index) => setActiveTabIndex(index)}>
              <div className="row align-items-center leaderboard-container">
                <div className="col-md-6">
                  <p className="page-heading">
                    {t(translationConstants.nationalLeaderboard)}
                  </p>
                </div>
              </div>

              <div className="row leaderboard-container">
                <div className="col-12">
                  <TabList>
                    <Tab>{t(translationConstants.sailing)}</Tab>
                    <Tab>{t(translationConstants.kitesurfing)}</Tab>
                    <Tab>{t(translationConstants.windsurfing)}</Tab>
                    <Tab>{t(translationConstants.wingfoiling)}</Tab>
                  </TabList>
                </div>
              </div>

              <FilterComponent
                className="leaderboard-container"
                gridState={gridState}
                sportId={currentSportId}
                setGridState={setGridState}
              />

              <TabPanel>
                <LeaderboardDetail
                  gridState={gridState}
                  setGridState={setGridState}
                  sportId={sportConstants.SAILING}
                />
              </TabPanel>
              <TabPanel>
                <LeaderboardDetail
                  gridState={gridState}
                  setGridState={setGridState}
                  sportId={sportConstants.KITESURFING}
                />
              </TabPanel>
              <TabPanel>
                <LeaderboardDetail
                  gridState={gridState}
                  setGridState={setGridState}
                  sportId={sportConstants.WINDSURFING}
                />
              </TabPanel>
              <TabPanel>
                <LeaderboardDetail
                  gridState={gridState}
                  setGridState={setGridState}
                  sportId={sportConstants.WINGFOILING}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>

      {/* Temporarily Hidden  */}
      {/* <div className="col-md-2 col-12 sponser-side">
        <SponserSideBar/>
      </div> */}
    </div>
  );
};

export default Leaderboard;
